export default function Flip() {
  window.addEventListener('load', () => {
    const buttons = document.querySelectorAll(
      '.a-button .a-button__icon-mask svg'
    )

    buttons.forEach((svg) => {
      const svgString = new XMLSerializer().serializeToString(svg)
      const encoded = encodeURIComponent(svgString)
        .replace(/'/g, '%27')
        .replace(/"/g, '%22')

      const styleTarget = svg.closest('.a-button__icon-mask')
      if (styleTarget) {
        styleTarget.style.setProperty(
          '--scroll-icon',
          `url("data:image/svg+xml,${encoded}")`
        )
      }
    })
  })
}
